/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SettingsImport } from './routes/settings'
import { Route as OverridesImport } from './routes/overrides'
import { Route as OrdersImport } from './routes/orders'
import { Route as LocalizationImport } from './routes/localization'
import { Route as DisplayImport } from './routes/display'
import { Route as IndexImport } from './routes/index'
import { Route as MethodUuidIndexImport } from './routes/method.$uuid.index'

// Create/Update Routes

const SettingsRoute = SettingsImport.update({
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const OverridesRoute = OverridesImport.update({
  path: '/overrides',
  getParentRoute: () => rootRoute,
} as any)

const OrdersRoute = OrdersImport.update({
  path: '/orders',
  getParentRoute: () => rootRoute,
} as any)

const LocalizationRoute = LocalizationImport.update({
  path: '/localization',
  getParentRoute: () => rootRoute,
} as any)

const DisplayRoute = DisplayImport.update({
  path: '/display',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const MethodUuidIndexRoute = MethodUuidIndexImport.update({
  path: '/method/$uuid/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/display': {
      id: '/display'
      path: '/display'
      fullPath: '/display'
      preLoaderRoute: typeof DisplayImport
      parentRoute: typeof rootRoute
    }
    '/localization': {
      id: '/localization'
      path: '/localization'
      fullPath: '/localization'
      preLoaderRoute: typeof LocalizationImport
      parentRoute: typeof rootRoute
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersImport
      parentRoute: typeof rootRoute
    }
    '/overrides': {
      id: '/overrides'
      path: '/overrides'
      fullPath: '/overrides'
      preLoaderRoute: typeof OverridesImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/method/$uuid/': {
      id: '/method/$uuid/'
      path: '/method/$uuid'
      fullPath: '/method/$uuid'
      preLoaderRoute: typeof MethodUuidIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/display': typeof DisplayRoute
  '/localization': typeof LocalizationRoute
  '/orders': typeof OrdersRoute
  '/overrides': typeof OverridesRoute
  '/settings': typeof SettingsRoute
  '/method/$uuid': typeof MethodUuidIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/display': typeof DisplayRoute
  '/localization': typeof LocalizationRoute
  '/orders': typeof OrdersRoute
  '/overrides': typeof OverridesRoute
  '/settings': typeof SettingsRoute
  '/method/$uuid': typeof MethodUuidIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/display': typeof DisplayRoute
  '/localization': typeof LocalizationRoute
  '/orders': typeof OrdersRoute
  '/overrides': typeof OverridesRoute
  '/settings': typeof SettingsRoute
  '/method/$uuid/': typeof MethodUuidIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/display'
    | '/localization'
    | '/orders'
    | '/overrides'
    | '/settings'
    | '/method/$uuid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/display'
    | '/localization'
    | '/orders'
    | '/overrides'
    | '/settings'
    | '/method/$uuid'
  id:
    | '__root__'
    | '/'
    | '/display'
    | '/localization'
    | '/orders'
    | '/overrides'
    | '/settings'
    | '/method/$uuid/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DisplayRoute: typeof DisplayRoute
  LocalizationRoute: typeof LocalizationRoute
  OrdersRoute: typeof OrdersRoute
  OverridesRoute: typeof OverridesRoute
  SettingsRoute: typeof SettingsRoute
  MethodUuidIndexRoute: typeof MethodUuidIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DisplayRoute: DisplayRoute,
  LocalizationRoute: LocalizationRoute,
  OrdersRoute: OrdersRoute,
  OverridesRoute: OverridesRoute,
  SettingsRoute: SettingsRoute,
  MethodUuidIndexRoute: MethodUuidIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/display",
        "/localization",
        "/orders",
        "/overrides",
        "/settings",
        "/method/$uuid/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/display": {
      "filePath": "display.tsx"
    },
    "/localization": {
      "filePath": "localization.tsx"
    },
    "/orders": {
      "filePath": "orders.tsx"
    },
    "/overrides": {
      "filePath": "overrides.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/method/$uuid/": {
      "filePath": "method.$uuid.index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
